// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iecg","left":"styles_left__1sQvh","desktopActions":"styles_desktopActions__3-icT","title":"styles_title__27FZ9"};